<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="image" src="images/title.png"/></p>
<p class="title-para">CONQUERING THE<br/>MASTER WITHIN</p>
<p class="title-author">PAUL A. HENDERSON</p>
<p class="publisheri"><img alt="image" src="images/pub.png"/></p>
<p class="publisher">NEW YORK</p>
<p class="publishers">LONDON • NASHVILLE • MELBOURNE • VANCOUVER</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?25053542